module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_1340031597235301.988709f0.jpg";